import {
  AfterViewInit,
  Component,
  computed,
  contentChild,
  DestroyRef,
  inject,
  input,
  model,
  signal,
  TemplateRef,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { EditModeDirective, ViewModeDirective } from '../../directives';
import { FormControl } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  imports: [NgTemplateOutlet],
  selector: 'wcg-inline-editor',
  styleUrls: ['./inline-editor.component.css'],
  template: `
    @defer (when exposedView()) {
      <ng-container [ngTemplateOutlet]="exposedView()"></ng-container>
    }
  `,
})
export class InlineEditorComponent implements AfterViewInit {
  private readonly _destroyRef = inject(DestroyRef);
  private readonly _currentEditState = signal<'View' | 'Edit'>('View');
  viewModeTemplate = contentChild(ViewModeDirective, { read: TemplateRef });
  editModeTemplate = contentChild(EditModeDirective, { read: TemplateRef });

  defaultView = model<'View' | 'Edit'>('View');
  currentFormControl = input<FormControl<unknown>>();
  turnoffInlineEdit = input<boolean>(false);

  exposedView = computed(() => {
    return this.defaultView().toLowerCase() === 'view' &&
      this._currentEditState().toLowerCase() === 'view'
      ? this.viewModeTemplate()!
      : this.editModeTemplate()!;
  });

  /** Lifecycle Hooks */
  ngAfterViewInit() {
    this._customListener();
  }
  /** Lifecycle Hooks */
  private _customListener() {
    if (this.currentFormControl()) {
      this.currentFormControl()
        ?.valueChanges.pipe(takeUntilDestroyed(this._destroyRef))
        .subscribe({
          next: () => {
            if (this.currentFormControl()?.valid) {
              this._currentEditState.set('View');
            }
          },
        });
    }
  }
}
